import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  public componentEmitter = new BehaviorSubject<string>('');

  public getComponentEmitter() {
    return this.componentEmitter.asObservable();
  }
}
